import { gql } from 'react-apollo';
import { full as userFullData } from "../../../../graphql/fragments/user";
import { full as churchFullData } from "../../../../graphql/fragments/church";

export const getChurch = gql`
  query getChurch($churchId: Int!) {
    church: church_by_id(id: $churchId) {
      ...allChurchFields
      seniorPastor: senior_pastor {
        ...allUserFields
      }
      pastors {
        edges {
          node {
            ...allUserFields
          }
        }
      }
    }
  }

  ${userFullData}
  ${churchFullData}
`;



// WEBPACK FOOTER //
// ./src/components/pages/churches/queries/getChurch.js